import dayjs from 'utils/dayjs'

export const xAxisTickFormatter = (hour: number) => {
  return dayjs().hour(hour).subtract(1, 'hour').format('ha')
}
